export default [
	{
		code: 'Super User',
		name: 'Super User',
	},
	{
		code: 'Application User',
		name: 'Application User',
	},
	{
		code: 'API User',
		name: 'API User',
	}	
];